<template>
  <div>
    <el-button size="mini" icon="el-icon-plus" type="primary" @click="selectOrg" round>选择抄送人</el-button>
    <div class="option">
      <el-checkbox label="允许发起人添加抄送人" v-model="config.shouldAdd"></el-checkbox>
    </div>
    <org-items v-model="select"/>
    <dept-picker
      v-if="visible"
      :title="pickerTitle"
      :type="orgPickerType"
      multiple
      ref="orgPicker"
      :selected="select"
      @ok="selected"
      @close="close"/>
  </div>
</template>

<script>
import DeptPicker from '@/components/common/DeptPicker'
import OrgItems from '../OrgItems'

export default {
  name: 'CcNodeConfigVue',
  components: { DeptPicker, OrgItems },
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    select: {
      get () {
        return this.config.assignedUser || []
      },
      set (val) {
        this.config.assignedUser = val
      }
    }
  },
  data () {
    return {
      visible: false,
      pickerTitle: '选择',
      orgPickerType: 'user'
    }
  },
  methods: {
    selectOrg () {
      // this.$refs.orgPicker.show()
      this.pickerTitle = '选择抄送人'
      this.orgPickerType = 'user'
      this.visible = true
    },
    selected (select) {
      console.log(select)
      this.visible = false
      this.select = Object.assign([], select)
    },
    close () {
      this.visible = false
    },
    removeOrgItem (index) {
      this.select.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.option{
  color: #606266;
  margin-top: 20px;
  font-size: small;
}

.desc{
  font-size: small;
  color: #8c8c8c;
}
.org-item{
  margin: 5px;
}
</style>
